import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { FgpAristocratLaunchData } from '@/features/providers/aristocrat/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Aristocrat: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { url } = (data as FgpAristocratLaunchData).launchDetails;
  const { gameName } = useAppSelector(gameContextSelector);

  /**
   * @TODO: This is a temporary solution to add the operatorAlerts param to the url. Remove this when no longer needed.
   */

  const urlObj = new URL(url);
  const hasOperatorAlertsParam = urlObj.searchParams.has('operatorAlerts');
  const hasHomeButtonParam = urlObj.searchParams.has('homeButton');

  if (!hasOperatorAlertsParam) {
    urlObj.searchParams.append('operatorAlerts', 'true');
  }

  if (!hasHomeButtonParam) {
    urlObj.searchParams.append('homeButton', 'false');
  }

  return <GameFrame url={urlObj.toString()} title={gameName} />;
};
